import { ErrorCode, FileError } from 'react-dropzone';

export const getDropFileErrorMessage = (fileError: FileError) => {
  const { code, message } = fileError;

  switch (code) {
    case ErrorCode.FileInvalidType:
      return 'Only PDF files are supported';
    case ErrorCode.FileTooLarge:
      return 'File size must be less than 10MB';
    case ErrorCode.FileTooSmall:
      return 'Selected file is empty. Please choose a valid PDF file';
    case ErrorCode.TooManyFiles:
      return 'Only one file can be uploaded at a time';
    default:
      return message;
  }
};
